import React from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import BarQRCode from '../../../../components/common/BarQRCode'
import { getText } from '../../../../internal/TextLabels'
import BasisConfirmationForm from './BasisConfirmationForm'
import { CustomerTypeModel } from '../../models/private-models'
import CardInformationSelect from './CardInformationSelect'
import { getCardOrAccountNumber } from './utils'

const AccountInformation = ({
  selectedCard,
  availableCards,
  customerType,
  onChangeCard,
  getBasisConfirmationPdf,
}) => {
  return (
    <>
      <Conditional
        when={
          customerType === CustomerTypeModel.LEGAL || availableCards.length > 1
        }
      >
        <CardInformationSelect
          customerType={customerType}
          availableCards={availableCards}
          selectedCard={selectedCard}
          onChangeCard={cardNumber => onChangeCard(cardNumber)}
        />
      </Conditional>
      <Conditional when={!!selectedCard}>
        <BasisConfirmationForm
          style={{ marginTop: '20px' }}
          card={selectedCard}
          printBasisConfirmation={data => getBasisConfirmationPdf(data)}
        />
      </Conditional>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '2rem',
          padding: '2rem',
          border: '1px solid lightgrey',
          minHeight: '160px',
        }}
      >
        <Conditional when={!!selectedCard}>
          {() => (
            <BarQRCode
              style={{ margin: 'auto' }}
              accountNumber={getCardOrAccountNumber(selectedCard)}
            />
          )}
        </Conditional>
        <Conditional
          when={!selectedCard && customerType === CustomerTypeModel.LEGAL}
        >
          <strong style={{ color: '#444', margin: 'auto' }}>
            {getText('payApply.accountInformation.multipleCards')}
          </strong>
        </Conditional>
      </div>
    </>
  )
}

AccountInformation.propTypes = {
  selectedCard: PropTypes.object,
  availableCards: PropTypes.array,
  customerType: PropTypes.string.isRequired,
  onChangeCard: PropTypes.func.isRequired,
  getBasisConfirmationPdf: PropTypes.func.isRequired,
}

AccountInformation.defaultProps = {
  selectedCard: null,
  availableCards: [],
}

export default AccountInformation
